import { IssueEntity } from 'types/IssueEntity'
import { formatMoney, formatNumber } from '../../packages/utils/numberFormatters'
import { isUnit } from './sharesOrUnits'

export const getSubPriceLabel = ({
    issue,
    locale,
    showUnitToShareConversion = true,
}: {
    issue: Pick<
        IssueEntity,
        'ipoIntervalHigh' | 'ipoIntervalLow' | 'sharesInUnit' | 'type' | 'unitSubPrice' | 'currency'
    >
    locale: string
    showUnitToShareConversion?: boolean
}) => {
    const label = isUnit(issue) ? 'unit' : 'aktie'
    const formatMoneyOptions = {
        locale,
        currencySymbol: issue.currency,
    }

    if (issue.unitSubPrice === null) {
        if (issue.type === 'IPO' && issue.ipoIntervalLow && issue.ipoIntervalHigh) {
            return `${formatNumber(issue.ipoIntervalLow, { decimals: 2, locale })} - ${formatNumber(issue.ipoIntervalHigh, { decimals: 2, locale })} ${issue.currency} / ${label} (intervall)`
        }
        return 'Ej fastställt ännu'
    } else if (issue.sharesInUnit === null || (issue.sharesInUnit === 1 && !isUnit(issue))) {
        return `${formatMoney(issue.unitSubPrice, formatMoneyOptions)} / ${label}`
    } else if (issue.sharesInUnit >= 1 && isUnit(issue)) {
        if (showUnitToShareConversion) {
            return `${formatMoney(issue.unitSubPrice, formatMoneyOptions)} / unit.\nMotsvarande ${formatMoney(+issue.unitSubPrice / issue.sharesInUnit, formatMoneyOptions)} / aktie.`
        }
        return `${formatMoney(issue.unitSubPrice / issue.sharesInUnit, formatMoneyOptions)} per aktie`
    } else if (issue.sharesInUnit === 0) {
        return `${formatMoney(issue.unitSubPrice, formatMoneyOptions)} per unit`
    }
    return ''
}
